module.exports = __webpack_public_path__ + "static/media/ananya.8400e79e.jpeg";